<template>
  <div>
      <div style="float: right;width: 25%;">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>昨日最火菜品(前10)</span>
          </div>
          <div v-if="yestodayTop != null" v-for="(item,key) in yestodayTop" :key="key" class="text item">
            {{item.name}} - 被点{{item.realCount}}次
          </div>
        </el-card>
      </div>
      <div style="float: right;width: 25%">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>今日最火菜品(前10)</span>
          </div>
          <div v-if="todayTop != null" v-for="(item,key) in todayTop" :key="key" class="text item">
            {{item.name}} - 被点{{item.realCount}}次
          </div>
        </el-card>
      </div>
      <div style="float: left;width: 25%">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>上周最火菜品(前10)</span>
          </div>
          <div v-if="lastWeekTop != null" v-for="(item,key) in lastWeekTop" :key="key" class="text item">
            {{item.name}} - 被点{{item.realCount}}次
          </div>
        </el-card>
      </div>
      <div style="float: left;width: 25%">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>本周最火菜品(前10)</span>
          </div>
          <div v-if="nowWeekTop != null" v-for="(item,key) in nowWeekTop" :key="key" class="text item">
            {{item.name}} - 被点{{item.realCount}}次
          </div>
        </el-card>
      </div>
  </div>
</template>

<script>
    export default {
        name: "StatGoods",
        components: {
        },
        data() {
            return {
                yestodayTop:null,
                todayTop:null,
                lastWeekTop:null,
                nowWeekTop:null,
            }
        },
        mounted(){
            this.initData();
        },
        methods: {
            initData(){
                var that = this;
                that.$api.get('/store/home/goods/stat',null, response => {
                    if (response.status >= 200 && response.status < 300) {
                        var res = response.data;
                        if (res.code == 0) {
                            that.yestodayTop = res.data.yestodayStats;
                            that.todayTop = res.data.todayStats;
                            that.lastWeekTop = res.data.lastWeekStats;
                            that.nowWeekTop = res.data.nowWeekStats;
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                    } else {
                        this.$message({
                            message: "服务器维护中",
                            type: 'error'
                        });
                    }
                });

            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/pages/store/components/StatGoods.vue